import apiClient from './apiClient'

/**
 * Get all maingroups
 * @returns Array of id, name and type
 */
export const fetchMainGroups = async (languageCode) => await apiClient.get('/api/mainGroupIds', { languageCode })